import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * ConseillerRoute — garde de l'espace Conseillers (suivi des nouveaux
 * convertis). Calquée sur YouthRoute : le garde-fou frontend est advisory,
 * la vérification canonique vit côté backend (chaque /api/conseillers/*
 * passe par _require_conseiller / _require_lead).
 *
 * Autorise :
 *   - role in {admin, dg}
 *   - users avec conseillerAccess === true (conseiller)
 *   - users avec conseillerLead === true (responsable du département)
 */
const ConseillerRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#272727]">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#00A99D]" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = (user.role || '').toLowerCase();
  const hasAccess = role === 'admin' || role === 'dg'
    || !!user.conseillerAccess || !!user.conseillerLead;
  if (!hasAccess) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ConseillerRoute;
